import { forwardRef } from 'react';
import './FlowStep.css';

/**
 * One step of the reading, stacked under the one before it. It deals in
 * when the flow reaches it and stays on the page after; once the flow has
 * moved past it, it is locked (its controls disable themselves via their
 * own `locked` prop) but still there to scroll back to.
 */
const FlowStep = forwardRef(function FlowStep({ name, locked = false, children }, ref) {
  return (
    <section
      ref={ref}
      className={`flow-step flow-step--${name}${locked ? ' is-locked' : ''}`}
      data-step={name}
    >
      {children}
    </section>
  );
});

export default FlowStep;
